import { render, staticRenderFns } from "./PraticeSensitiveTopicsSection.vue?vue&type=template&id=08aad6ce"
import script from "./PraticeSensitiveTopicsSection.vue?vue&type=script&lang=ts"
export * from "./PraticeSensitiveTopicsSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeSensitiveTopicsSection.vue?vue&type=style&index=0&id=08aad6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports